export default {
  vacancyId: {
    type: 'string',
    required: true,
  },
};
